import { render, staticRenderFns } from "./email-policy.vue?vue&type=template&id=29bf953c&"
import script from "./email-policy.vue?vue&type=script&lang=js&"
export * from "./email-policy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports